module.exports = __webpack_public_path__ + "static/media/davi.050cc0f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/davi.png
// module id = 393
// module chunks = 0